import React, { FC, ReactNode } from 'react'
import s from './DefaultTag.module.sass'
import { Button } from '@shared/ui/Actions/Button'
import { ErrorBoundary } from '../../../../../lib/components/ErrorBoundary'
import { BtnFilterTagSkeleton } from '@shared/ui/Form/Single/Filters/DefaultTag/index'

interface Props {
  onClick?: () => void
  to?: string
  className?: string
  active?: boolean
  children: ReactNode
  counter?: number
  skeleton?: boolean
}

const DefaultTagContainer: FC<Props & React.ButtonHTMLAttributes<any>> = ({
  skeleton,
  className = '',
  children,
  to,
  ...props
}) => {
  return (
    <ErrorBoundary>
      {skeleton ? (
        <BtnFilterTagSkeleton className={className} />
      ) : (
        <DefaultTag className={className} to={to} {...props}>
          {children}
        </DefaultTag>
      )}
    </ErrorBoundary>
  )
}

const DefaultTag: FC<Props & React.ButtonHTMLAttributes<any>> = ({
  onClick,
  className = '',
  children,
  counter,
  active = false,
  to,
  ...props
}) => {
  return (
    <ErrorBoundary>
      {to ? (
        <Button.Link
          href={to}
          sizes='M'
          mode='white-border'
          className={`${s.button} ${className}`}
          onClick={onClick}
          data-active={active}
          {...props}>
          {children}
        </Button.Link>
      ) : (
        <Button
          sizes='M'
          mode='white-border'
          className={`${s.button} ${className}`}
          onClick={onClick}
          data-active={active}
          {...props}>
          {children}
          {counter && <span className={s.button__counter}>{counter}</span>}
        </Button>
      )}
    </ErrorBoundary>
  )
}

export default DefaultTagContainer
